import React from 'react';
import SubjectPage from '../../subjects/SubjectPage';

function OPTondonBook() {

  const pageTitleText = "OP Tondon Physical Chemistry";


  return (
    <>
    
      <SubjectPage 
        name={pageTitleText} 
        link="op-tondon-book" 
        type="optondonbook"
      />

    </>
  );
}

export default OPTondonBook;